/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';
import { TimeModel } from './time.model';
import { TimeProviderDetailModel } from '../time-provider/time-provider-detail.model';

@Injectable({providedIn: 'root'})
export class TimeService extends DataService<any> {
  constructor(protected dependencies: ApiDependenciesService) {
    super(dependencies);

  }

  async getCurrentTime(): Promise<TimeModel> {
    let model: TimeModel;
    await this.setEndpoint('/timeprovider/now')
      .getSingle()
      .then(response => {
        model = new TimeModel(null, response.currentDateTime, response.showTimeProvider);
      });
    return Promise.resolve(model);
  }  

  async getEditableItemDetail(): Promise<TimeProviderDetailModel> {
    let model: TimeProviderDetailModel;
    await this.setEndpoint('/timeprovider/detail')
      .getSingle()
      .then(response => {
        model = new TimeProviderDetailModel(null, response.now,  response.realTime,  response.fixedTime,  response.baseDate,  response.incrementDays,  response.incrementTime );
      });
    return Promise.resolve(model);
  }

  public async updateItem(formData: any) {
    return this.setEndpoint('/timeprovider/detail').update(formData);
  }
}
